"use client";
import { NavigateItem } from "@/api/home";
import Box from "@/components/Box";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

interface Props {
    data: NavigateItem[];
}

const NavigateBar: React.FC<Props> = ({ data }) => {
    const slidesPerView = React.useMemo(() => {
        if (data.length > 5) {
            return 4.5;
        }
        return 5;
    }, [data]);
    if (!data?.length) return null;
    return (
        <div className="px-[.1rem] py-[.05rem]">
            <Swiper spaceBetween={15} slidesPerView={slidesPerView}>
                {data.map((item) => {
                    console.log(1122, item);
                    return (
                        <SwiperSlide key={item.id}>
                            <Box
                                pl={false}
                                pt={false}
                                pr={false}
                                pb={false}
                                action={item.action_type}
                                actionData={item.action_params}
                            >
                                <div className="flex flex-col items-center justify-center">
                                    <img
                                        src={item?.icon_url}
                                        alt={item?.name}
                                        className="aspect-[1/1] max-w-[100%] rounded-[50%]"
                                    />
                                    <div className="mt-[.06rem] text-center text-[.1rem] text-[#fff]">
                                        {item.name}
                                    </div>
                                </div>
                            </Box>
                        </SwiperSlide>
                    );
                })}
            </Swiper>
        </div>
    );
};

export default NavigateBar;
